import {useTranslation} from "react-i18next";
export const PostCategorie = ({categorie})=>{
    const { t } = useTranslation();
    return  <div className={'PostCategorie ' +categorie}>
        {t(`${categorie}`)}
    </div>
}
